import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { PrivateNumberPricesWithPaginationForUserDto } from './../../../../core/api/models/private-number-prices-with-pagination-for-user-dto';
import { GetEnumValuesDto } from './../../../../core/api/models';
import { LoggerService } from 'src/app/core/services/logger.service';
import { EventTypes } from 'src/app/core/constants/event-types';

@Component({
    selector: 'app-private-numbers-price-card',
    templateUrl: './private-numbers-price-card.component.html',
    styleUrls: ['./private-numbers-price-card.component.scss'],
    standalone: false
})
export class PrivateNumbersPriceCardComponent implements OnInit {

  @Input() model: PrivateNumberPricesWithPaginationForUserDto;
  @Input() SmsCpEnumValues: GetEnumValuesDto[] = [];
  @Input() vocabsPath: string;
  @Input() parentLoading: boolean;
  buyButtonLoading: boolean;

  @Output() selectedPrivateNumberPrice = new EventEmitter<PrivateNumberPricesWithPaginationForUserDto>();

  constructor(protected loggerService: LoggerService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes["parentLoading"]) {
        const timeOut = setTimeout(() => {
          this.buyButtonLoading = false;
          clearTimeout(timeOut)
        }, 500);
      }

    } catch (error) {
      this.loggerService.logError('app-private-numbers-price-card', error, EventTypes.privateNumberPrice)
    }

  }

  onEmitSelectedPrivateNumberPrice() {
    if(this.buyButtonLoading) return;
    this.buyButtonLoading = true;
    this.selectedPrivateNumberPrice.emit(this.model);
  }

}